var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.444,
    height: 24.23,
    viewBox: "0 0 19.444 24.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.104)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.1,117v18.023H54.03v-3.714h1.592v3.714h8.926V117Zm9.067,11.938H47.845v-1.592h6.326v1.592Zm0-3.714H47.845v-1.592h6.326v1.592Zm0-3.714H47.845v-1.592h6.326v1.592Zm7.637,7.428H55.85v-1.592h5.957v1.592Zm0-3.714H55.85v-1.592h5.957v1.592Zm0-3.714H55.85v-1.592h5.957v1.592Z",
    transform: "translate(0 -110.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.108,2.653H89.7V4.616h2.208V2.653H93.5V4.616h2.208V2.653H97.3V4.616h3V0H85.1V4.616h3Z",
    transform: "translate(-37.878)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.33f30d9b885ea1cc198faef428069404.svg";
export { ForwardRef as ReactComponent };